export enum UploadSources {
  UnrestrictedAssets = 'assets',
  RestrictedAssets = 'secure-assets',
  TestQuestions = 'tests',
  SurveyQuestions = 'surveys',
}
